import React, { Component } from 'react'
import { observer } from 'mobx-react'
import {observable} from 'mobx'
import { extendObservable } from 'mobx'
import RadioButton from './RadioButton'
import Checkbox from './Checkbox'
import {parseHtmlForReact} from '../../helpers'
//import '../../../assets/css/horizontalSingleAxis.css';

@observer
export default class HorizontalSingleAxis extends Component {

    @observable allowMultiLine = false

	constructor(props){
		super(props)
        this.handleChange = this.handleChange.bind(this)
        // this.answerWidth = 140 // px
        // this.answerMarginRight = 14 // px
        this.divRef = React.createRef()
	}

    componentDidMount() {
        const {question, store} = this.props
        const questionId = question.id
        
        const element = this.divRef.current
        const parent = element.parentElement
        console.log(element.offsetWidth, (parent ? parent.offsetWidth : -1))
        if (element.offsetWidth > parent.offsetWidth) {
            // parent.style['overflow-y'] = 'auto'
            this.allowMultiLine = question.questionTypeCode === 'RD'
        }
        
    }


	handleChange(option, e) {
		const {question, store} = this.props
		// const {form_data} = store
		// const name = e.target.name
		const value = e.target.value
		//this.props.form_data.set(name, value)
		store.addFormResponse(question, value, option)
	}

    getMultiOptions = (options) => {
        const {
            question,
            store,
            handleChange,
            type,
            width,
            marginRight,
        } = this.props
        const inputType = type ? type : 'radio'
		// const width = 100 / options.length
        return options.filter(o => o.willDisplay !== false).map((option) => (
            option.isHidden ? null 
                : <div key={option.id} style={{display: 'inline-block', textAlign: 'center', marginBottom: '1em',marginLeft: '-1px', border: '1px solid #bbb'}}>
                    <div style={{height: '4em', lineHeight: '4em'}}>{parseHtmlForReact(store.getOptionTitle(option, question))}</div>
                    <div style={{height: '4em', borderTop: '1px solid #bbb'}}>
                        {inputType === 'radio' &&
                            <RadioButton handleChange={handleChange}
                                store={store}
                                option={option}
                                question={question}
                                other={option.hasOwnProperty('other') ? option.other : null}
                                mode='horizontal'
                                width={width}
                                marginRight={marginRight}
                            />
                        }
                        { inputType !== 'radio' &&
                            <Checkbox handleChange={handleChange}
                                store={store}
                                option={option}
                                questionType={questionType}
                                questionId={questionId}
                                question={question}
                                other={option.hasOwnProperty('other') ? option.other : null}
                                mode='horizontal'
                                width={width}
                                marginRight={marginRight}
                            />
                        }
                    </div>
                </div>
        ))
    }

	render() {
		// var content
		const {
            question,
            store,
            handleChange,
            type,
            width,
            marginRight,
        } = this.props
		// const {form_data} = store
		const set = question.optionSet
		const options = set.options
		const questionType = question.questionTypeCode
		const questionId = question.id

		const inputType = type ? type : 'radio'
		// const width = 100 / options.length
        // const headerContent = options.map((option) => {
        //     if (option.isHidden) {
        //         return null
        //     }
		// 	else {
        //         return <td style={{"width": width+"%"}} key={option.id}>{parseHtmlForReact(store.getOptionTitle(option, question))}</td>
        //     }
        // })

		const rowContent = options.map((option) => {
            
            if (option.isHidden) {
                return null
            } else if(inputType === "radio"){
				return (
                    <RadioButton
                        handleChange={handleChange}
                        key={option.id}
                        store={store}
                        option={option}
                        question={question}
                        other={option.hasOwnProperty("hasOptionOther") ? option.hasOptionOther : null}
                        mode="horizontal"
                        width={width}
                        marginRight={marginRight}
                    />
				)
			} else {
				return (
                    <Checkbox
                        key={option.id}
                        handleChange={handleChange}
                        store={store}
                        option={option}
                        questionType={questionType}
                        questionId={questionId}
                        question={question}
                        other={option.hasOwnProperty("hasOptionOther") ? option.hasOptionOther : null}
                        mode="horizontal"
                        width={width}
                        marginRight={marginRight}
                    />
				)
			}

        })

        return ( 
            <div>
                {!this.allowMultiLine &&
                    <div ref={this.divRef} className="single-multiple-choice-horizontal-con">
                        {rowContent}
                    </div>
                }
                {this.allowMultiLine && 
                    <div>{this.getMultiOptions(options)}</div>
                }
            </div>
        )
	}
}
